import { allow_num } from "@/utils/validations";
import {validate_id} from "@/utils/validations";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
    name: 'RsaIdVerification',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    components:{
      BreadCrumb,
      ClientLogo
    },
    data: () => ({
        id_number: '',
        first_name: '',
        last_name: '',
        is_loading: false,
        is_field_disabled: {
            id_number: false,
            first_name: false,
            last_name: false
        },
        is_id_valid: false
    }),

    computed: {
      workflow_id() {
        return this.$store.getters.get_workflow_id;
      }
    },

    methods: {
      allow_numeric(event) {
        this.id_number = allow_num(event);
        this.is_id_valid = validate_id(this.id_number);
      },
      
      allow_alphabetic(event) {
        const field_name = event.target.id;
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        const cleaned_value = value.replace(/[^a-zA-Z\s]/g, '');
        
        if (field_name === 'first_name') {
          this.first_name = cleaned_value;
          event.target.value = cleaned_value;
        } else if (field_name === 'last_name') {
          this.last_name = cleaned_value;
          event.target.value = cleaned_value;
        }
      },

      validate_form() {
        // Validate ID number
        if (!this.id_number.trim()) {
          $('.id-message').removeClass('d-none');
          setTimeout(() => {
            $('.id-message').addClass('d-none');
          }, 3000);
          return false;
        }

        if (!validate_id(this.id_number)) {
          $('.invalid-id-message').removeClass('d-none');
          setTimeout(() => {
            $('.invalid-id-message').addClass('d-none');
          }, 3000);
          return false;
        }

        // Validate first name
        if (!this.first_name.trim()) {
          $('.first-name-message').removeClass('d-none');
          setTimeout(() => {
            $('.first-name-message').addClass('d-none');
          }, 3000);
          return false;
        }

        // Validate last name
        if (!this.last_name.trim()) {
          $('.last-name-message').removeClass('d-none');
          setTimeout(() => {
            $('.last-name-message').addClass('d-none');
          }, 3000);
          return false;
        }

        return true;
      },

      verify_rsa_id() {
        if (!this.validate_form()) {
          return;
        }

        this.rsa_id_verification_api();
      },

      rsa_id_verification_api() {
        const TOKEN = localStorage.getItem('token');
        const RSA_ID_VERIFICATION_URL = `${API_BASE_URL}/verify_api/personnel_verification/verify_rsa_id/`;
        const DATA = {
          id_number: this.id_number,
          first_names: this.first_name,
          last_name: this.last_name,
          workflow_id: this.workflow_id,
          on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
        };

        this.is_loading = true;

        $.ajax({
          url: RSA_ID_VERIFICATION_URL,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          data: JSON.stringify(DATA),
          beforeSend: () => {
            Swal.fire({
              text: 'Verifying ID...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
          },
          success: (response) => {
            Swal.close();
            this.is_loading = false;
            
            const status_message = response.status;

            if (status_message === "success") {
                this.completeService();
        
                this.id_number = '';
                this.first_names = '';
                this.last_name = '';
  
            } else if (response.error_message) {
              Swal.fire({
                icon: 'error',
                title: 'Verification Failed',
                text: response.error_message,
              });
            } else {
              Swal.fire({
                icon: 'error',
                text: "Verification failed. Please check the details and try again.",
              });
            }
          },
          error: (error) => {
            Swal.close();
            this.is_loading = false;

            if (error.status === 400 && error.responseJSON) {
              // Handle validation errors
              let error_message = '';
              
              if (error.responseJSON.id_number) {
                error_message = error.responseJSON.id_number[0];
              } else if (error.responseJSON.first_name) {
                error_message = error.responseJSON.first_name[0];
              } else if (error.responseJSON.last_name) {
                error_message = error.responseJSON.last_name[0];
              } else if (error.responseJSON.error) {
                error_message = error.responseJSON.error;
              } else {
                error_message = "Invalid input. Please check your details.";
              }

              Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: error_message,
              });
            } else if (error.status === 500) {
              Swal.fire({
                icon: 'error',
                text: "Our service is currently unavailable. Please try again later.",
              });
            } else {
              Swal.fire({
                icon: 'error',
                text: "An error occurred. Please check your connection and try again.",
              });
            }
          }
        });
      },

      disable_fields() {
        this.is_field_disabled.id_number = true;
        this.is_field_disabled.first_name = true;
        this.is_field_disabled.last_name = true;
      },

      enable_fields() {
        this.is_field_disabled.id_number = false;
        this.is_field_disabled.first_name = false;
        this.is_field_disabled.last_name = false;
      },

      sync_form_data() {

        PREPOPULATE_INPUT.methods.sync_form_data.call(this);
        
 
        this.is_id_valid = validate_id(this.id_number);
      }
    },

    watch: {
      id_number(newValue) {
        this.is_id_valid = validate_id(newValue);
      }
    },

    mounted() {
      if (!validateToken(this.$router)) {
        return;
      }
      this.get_customer_data();
    },

    beforeDestroy() {
      // Any cleanup if needed
    }
};